export default class betoniAttrDataClass {
  attrId;
  keikkaId;
  keikkaBetoniAttrId;
  attrNimike;
  attrSelite;
  attrHelpId;
  keikkaBetoniAttrComment = null;
  constructor() {
    this.attrId = null;
    this.keikkaId = null;
    this.keikkaBetoniAttrId = null;
    this.attrNimike = null;
    this.attrSelite = null;
    this.attrHelpId = null;
    this.keikkaBetoniAttrComment = null;
  }
}
